import { createSettingDocumentType, deleteSettingDocumentType, getSettingDocumentTypes, patchSettingDocumentType } from "../api/EnzianSettingsApi";
import { handleStoreError } from "./GeneralStore";
import { createSimpleListConfiguration, createSimpleListListFilter } from "../types/ListTypes";
import { _ } from "svelte-i18n";
import { get } from "svelte/store";
export function createSettingDocumentTypesStore() {
    let internalSettingDocumentTypeStore = $state([]);
    let storeListeners = $state([]);
    let listFilter = $state(createSimpleListListFilter({
        showFilterIcon: false,
        size: 25,
        localStorageKey: 'document-types-list',
        filterOptions: [
            {
                label: get(_)('settings.basic.document_labels.lbl_name'),
                value: null,
                key: 'defaultName',
                type: 'string',
                isSorting: false
            }
        ]
    }));
    let listConfig = $state(createSimpleListConfiguration({
        header: get(_)('settings.basic.document_labels.list_header'),
        showEmptyAdd: false,
        cardModeConfig: {
            amountOfCols: 5
        }
    }));
    async function loadData() {
        try {
            const documentTypes = await getSettingDocumentTypes(listFilter);
            if (listFilter.page == 0) {
                //Set the data.
                internalSettingDocumentTypeStore = documentTypes;
            }
            else {
                //Merge the lists
                internalSettingDocumentTypeStore.push(...documentTypes);
            }
            //Increase the page counter.
            if (internalSettingDocumentTypeStore.length > 0) {
                listFilter.page += 1;
            }
        }
        catch (error) {
            handleStoreError('settings.basic.document_labels.err_load', error);
        }
    }
    return {
        get data() { return internalSettingDocumentTypeStore; },
        get listFilter() { return listFilter; },
        set listFilter(value) { listFilter = value; },
        get listConfig() { return listConfig; },
        set listConfig(value) { listConfig = value; },
        addNotifier(listener) {
            storeListeners.push(listener);
        },
        removeNotifier(listener) {
            storeListeners = storeListeners.filter((li) => li == listener);
        },
        loadData: loadData,
        async applyFilter() {
            //Reset the start id
            listFilter.page = 0;
            //Load the data.
            await loadData();
            //Inform the listeners
            storeListeners.forEach((listener) => {
                //Call the event
                listener.onFilterApplied();
            });
        },
        clear() {
            internalSettingDocumentTypeStore = [];
        },
        async createSettingDocumentTypeStore(request) {
            const newValue = await createSettingDocumentType(request);
            internalSettingDocumentTypeStore.push(newValue);
        },
        async deleteDocumentTypeStore(settingDocumentTypeId) {
            await deleteSettingDocumentType(settingDocumentTypeId);
            internalSettingDocumentTypeStore = internalSettingDocumentTypeStore.filter((setting) => setting.id != settingDocumentTypeId);
        },
        async patchSettingDocumentTypeStore(settingDocumentTypeId, request) {
            const updatedValue = await patchSettingDocumentType(settingDocumentTypeId, request);
            const index = internalSettingDocumentTypeStore.findIndex((setting) => setting.id == settingDocumentTypeId);
            if (index != undefined) {
                internalSettingDocumentTypeStore[index] = updatedValue;
            }
        }
    };
}
